/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { MRT_ColumnDef } from "material-react-table"
import { LensRow } from "../../constants"
import {ETrackedItemTypes} from "../../../../../constants/trackedItems";

const FAVORITE_TYPE = ETrackedItemTypes.CAMERA_CONFIGURATION
const INNERVTAB_URL_PARAM = 'innervtabs-1'
const FAVORITE_PARAM_ID = INNERVTAB_URL_PARAM
const TRACKED_ITEM_UID_PREFIX = "CameraConfig"
const TRACKED_ITEM_LABEL_PREFIX = "Camera"


export interface CamerarPropertiesTableRow{
  propertyName: string
  propertyValue: string
  unit: string
}
export interface CamerarPropertiesObject{
  key: string
  label: string
  unit: string
}
export const cameraPropsKeyToTitleMap: CamerarPropertiesObject[] = [
  {
    key: "resolutionMP",
    label: "Resolution (MP)",
    unit: "megapixels"
  },
  {
    key: "horizontalPixels",
    label: "Horizontal Pixels",
    unit: ""
  },
  {
    key: "verticalPixels",
    label: "Vertical Pixels",
    unit: ""
  }, 
  {
    key: "aspectRatio",
    label: "Aspect Ratio", 
    unit: ""
  },
  {
    key: "resolution",
    label: "Resolution", 
    unit: ""
  },
  {
    key: "imagerComponent",
    label: "Imager Component", 
    unit: ""
  },
  {
    key: "imagerSupplier",
    label: "Imager Supplier", 
    unit: ""
  },
  {
    key: "imagerType",
    label: "Imager Type", 
    unit: ""
  },
  {
    key: "imagerVersion",
    label: "Imager Version", 
    unit: ""
  },
  
]

export const cameraLensPropsKeyToTitleMap: CamerarPropertiesObject[] = [
  {
    key: "lensComponent",
    label: "Lens Component",
    unit: ""
  },
  {
    key: "lensFocalPoint",
    label: "Lens Focal Point",
    unit: ""
  },
  {
    key: "lensSupplier",
    label: "Lens Supplier",
    unit: ""
  }, 
  {
    key: "lensType",
    label: "Lens Type", 
    unit: ""
  },
  {
    key: "lensVersion",
    label: "Lens Version", 
    unit: ""
  },
]

export const fovAndBoresightCameraKeyToLabelMap: CamerarPropertiesObject[] = [
  {
    key: "azimuth_fov",
    label: "Azimuth FOV",
    unit: "deg"
  },
  {
    key: "elevation_fov",
    label: "Elevation FOV",
    unit: "deg"
  },
  {
    key: "max_range",
    label: "Max Det. Range at Boresight",
    unit: "m"
  }
]

export const lensColumns : MRT_ColumnDef<LensRow>[] = [
    {
      accessorKey: 'fov',
      header: 'FOV',
    },
    {
      accessorKey: 'paraxial_height',
      header: 'Paraxial Height',
    },
    {
      accessorKey: 'real_height',
      header: 'Real Height',
    },
    {
      accessorKey: 'op_distance',
      header: 'OP Dist.',
    },
    {
      accessorKey: 'angular_resolution',
      header: 'Angular Resolution',
      minSize: 200,
    },
  ]
export interface ObjectPropertiesInput{
  key: string
  label: string
  isDropDown: boolean
  unit: string
}

export interface ObjectPropertyRow{
  objectPropertyName: string
  unit: string
  objectPropertyValue: string
  objectPropertyKey: string
}

export const objectPropertiesInput: ObjectPropertiesInput[] = [
  {
    key: "objectCategory",
    label: "Object Category",
    unit: "",
    isDropDown: true
  },
  {
    key: "objectName",
    label: "Object Name",
    unit: "",
    isDropDown: true
  },
  {
    key: "objectVersion",
    label: "Object Version",
    unit: "",
    isDropDown: true
  },
  {
    key: "objectProperties",
    label: "Object Variants",
    isDropDown: true,
    unit: ""
  },
  {
    key: "orientationWidth",
    label: "Orientation Width (m)",
    isDropDown: false,
    unit: "m"
  },
  {
    key: "orientationHeight",
    label: "Orientation Height (m)",
    unit: "m",
    isDropDown: false
  },
  {
    key: "selectDimension", 
    unit: "",
    label: "Dimension", 
    isDropDown: true
  },  
  {
    key: "dimensionValue",
    label: "Dimension Value (m)",
    unit: "m",
    isDropDown: false
  },  
  {
    key: "pixelCount",
    label: "Pixel Count",
    unit: "",
    isDropDown: false
  }
]
// Column names for the Blueline export
export const COLUMN_NAMES = {
  X: "X (m)",
  Y: "Y (m)",
}
export {
  FAVORITE_TYPE,
  INNERVTAB_URL_PARAM,
  FAVORITE_PARAM_ID,
  TRACKED_ITEM_UID_PREFIX,
  TRACKED_ITEM_LABEL_PREFIX
}